var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import codes from "../errorCodes/Login";
import isAuthedQuery from "./queries/isAuthed";
var WhoAmI = /** @class */ (function () {
    function WhoAmI() {
    }
    WhoAmI.prototype.isAuthed = function (options) {
        if (options === void 0) { options = {}; }
        return client
            .query(__assign(__assign({}, options), { fetchPolicy: "no-cache", query: isAuthedQuery }))
            .catch(function () {
            var e = new Error();
            e.code = codes.InvalidLoginDetails;
            throw e;
        })
            .then(function () { return true; });
    };
    return WhoAmI;
}());
var whoAmI = new WhoAmI();
export var isAuthed = whoAmI.isAuthed;
export default whoAmI;
